import { Expose, Type } from 'class-transformer'
import { ValidateNested } from 'class-validator'
import { Politician } from '../../entity'

export class GetPoliticiansDTO {

    @Expose()
    @ValidateNested()
    @Type( () => Politician )
    politicians!: Politician[]

}